import './ButtonLink.css'

export const ButtonLink = ({ text, onClick }) => {
  return (
    <button className="button-link m-1" onClick={onClick}>{text}</button>
  );
};